import styled from "styled-components";

export const StyledServiceOrderListHeaderTitle = styled.p`
  font-weight: 600;
  font-size: 1.6rem;
`;
